import React, { useState, useEffect, useMemo } from 'react';
import './Payment.css';


const PLANS = {
  m1:  { id: 'm1',  label: '1 месяц',    price: 299,  perMonth: 299, days: 30,  minGb: 50,  discount: null },
  m3:  { id: 'm3',  label: '3 месяца',   price: 849,  perMonth: 283, days: 90,  minGb: 150, discount: '−6%' },
  m6:  { id: 'm6',  label: '6 месяцев',  price: 1599, perMonth: 266, days: 180, minGb: 300, discount: '−11%' },
  m12: { id: 'm12', label: '12 месяцев', price: 2749, perMonth: 229, days: 365, minGb: 600, discount: '−25%' },
};

const GB_TIERS = [50, 100, 150, 300, 600, 1000, 2000, 3000];


const PRICE_TABLE = {
  m1: {  // 30 дней, база 50 ГБ = 299 ₽
    50: 299,
    100: 339,   // +50 × 0.80
    150: 375,   // +100 × 0.76
    300: 482,   // +250 × 0.73
    600: 690,   // +550 × 0.71
    1000: 959,  // +950 × 0.695
    2000: 1639, // +1950 × ~0.687
    3000: 2309, // +2950 × ~0.682
  },
  m3: {  // 90 дней, база 150 ГБ = 849 ₽
    150: 849,
    300: 959,   // +150 × 0.73
    600: 1169,  // +450 × 0.71
    1000: 1440, // +850 × 0.695
    2000: 2119, // +1850 × ~0.687
    3000: 2789, // +2850 × ~0.682
  },
  m6: {  // 180 дней, база 300 ГБ = 1599 ₽
    300: 1599,
    600: 1812,  // +300 × 0.71
    1000: 2086, // +700 × 0.695
    2000: 2765, // +1700 × ~0.687
    3000: 3434, // +2700 × ~0.682
  },
  m12: { // 365 дней, база 600 ГБ = 2749 ₽
    600: 2749,
    1000: 3033, // +400 × 0.71
    2000: 3702, // +1400 × ~0.681
    3000: 4369, // +2400 × ~0.675
  },
};

function getUnitPrice(planId, gb) {
  const table = PRICE_TABLE[planId];
  if (table && table[gb] != null) return table[gb];
  const plan = PLANS[planId] || PLANS.m3;
  const known = Object.keys(table || {})
    .map(Number)
    .filter((t) => t <= gb)
    .sort((a, b) => b - a);
  if (known.length) {
    const baseGb = known[0];
    const basePrice = table[baseGb];
    const rate = 0.68; 
    return Math.round(basePrice + (gb - baseGb) * rate);
  }
  return plan.price;
}

const planCardStyle = (active) => ({
  position: 'relative',
  cursor: 'pointer',
  borderRadius: '16px',
  padding: '18px',
  background: active
    ? 'linear-gradient(120deg, rgba(58,158,127,0.14), rgba(74,174,136,0.07))'
    : 'rgba(255,255,255,0.02)',
  border: active
    ? '1px solid rgba(74,174,136,0.5)'
    : '1px solid rgba(255,255,255,0.08)',
  boxShadow: active ? '0 0 0 3px rgba(74,174,136,0.12)' : 'none',
});

const payMethodStyle = (active) => ({
  cursor: 'pointer',
  padding: '13px 20px',
  borderRadius: '12px',
  fontSize: '14px',
  fontWeight: 600,
  color: active ? '#eafff2' : '#96a0ad',
  background: active
    ? 'linear-gradient(120deg, rgba(58,158,127,0.14), rgba(74,174,136,0.07))'
    : 'rgba(255,255,255,0.02)',
  border: active
    ? '1px solid rgba(74,174,136,0.4)'
    : '1px solid rgba(255,255,255,0.08)',
});

const gbOptionStyle = (active) => ({
  cursor: 'pointer',
  padding: '11px 18px',
  borderRadius: '11px',
  fontSize: '14px',
  fontWeight: 600,
  color: active ? '#06080b' : '#c8d0d9',
  background: active
    ? 'linear-gradient(120deg, #0f5f4a, #3a9e7f)'
    : 'rgba(255,255,255,0.03)',
  border: active ? 'none' : '1px solid rgba(255,255,255,0.10)',
});

const Payment = ({
  payManage,
  payCheckout,
  subsVM = [],
  anySelected,
  selectedCount,
  startRenew,
  startNew,
  backToManage,
  hasSub,
  payMode,
  onPayment,
  plan: planProp,
  method: methodProp,
  pickM1,
  pickM3,
  pickM6,
  pickM12,
  pickCard,
  pickSbp,
  pickStars,
  pickCrypto,
  planM1Style,
  planM3Style,
  planM6Style,
  planM12Style,
  payCardStyle,
  paySbpStyle,
  payStarsStyle,
  payCryptoStyle,
  checkoutBanner,
  checkoutSummaryLabel: checkoutSummaryLabelProp,
  totalLabel: totalLabelProp,
  payButtonLabel: payButtonLabelProp,
  infoOpen: infoOpenProp,
  toggleInfo: toggleInfoProp,
  deviceLimit = 5,
  minGbLabel: minGbLabelProp,
  selectedGb: selectedGbProp,
  gbOptions: gbOptionsProp,
  onGbChange,
  onPlanChange,
  onMethodChange,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [localPlan, setLocalPlan] = useState(planProp || 'm3');
  const [localMethod, setLocalMethod] = useState(methodProp || 'card');
  const [localGb, setLocalGb] = useState(selectedGbProp || PLANS.m3.minGb);
  const [localInfoOpen, setLocalInfoOpen] = useState(false);

  const plan = planProp ?? localPlan;
  const method = methodProp ?? localMethod;
  const infoOpen = infoOpenProp ?? localInfoOpen;
  const cur = PLANS[plan] || PLANS.m3;

  useEffect(() => {
    if (planProp != null) setLocalPlan(planProp);
  }, [planProp]);

  useEffect(() => {
    setLocalGb((prev) => {
      const next = Math.max(prev, cur.minGb);
      if (next !== prev) onGbChange?.(next);
      return next;
    });
  }, [plan, cur.minGb]); 

  const selectedGb = localGb;
  const minGbLabel = minGbLabelProp ?? cur.minGb;

  const gbTiers = useMemo(
    () => GB_TIERS.filter((t) => t >= cur.minGb),
    [cur.minGb]
  );

  const pickGb = (t) => {
    setLocalGb(t);
    onGbChange?.(t);
  };

  const gbOptions = useMemo(
    () =>
      gbTiers.map((t) => ({
        label: t,
        pick: () => pickGb(t),
        style: gbOptionStyle(t === selectedGb),
      })),
    [gbTiers, selectedGb]
  );

  const unitPrice = getUnitPrice(plan, selectedGb);
  const units = payMode === 'renew' ? Math.max(1, selectedCount || 1) : 1;
  const total = unitPrice * units;

  const checkoutSummaryLabel = `${cur.days} дней · ${deviceLimit} устр. · ${selectedGb} ГБ${
    payMode === 'renew' && units > 1 ? ` × ${units}` : ''
  }`;

  const totalLabel = total.toLocaleString('ru-RU');

  const payButtonLabel = `${
    payMode === 'renew' ? 'Продлить' : 'Оплатить'
  } · ${total.toLocaleString('ru-RU')} ₽`;

  const handlePickPlan = (id) => {
    setLocalPlan(id);
    const min = PLANS[id].minGb;
    setLocalGb((prev) => {
      const next = Math.max(prev, min);
      onGbChange?.(next);
      return next;
    });
    onPlanChange?.(id);
    if (id === 'm1') pickM1?.();
    if (id === 'm3') pickM3?.();
    if (id === 'm6') pickM6?.();
    if (id === 'm12') pickM12?.();
  };

  const handlePickMethod = (id) => {
    setLocalMethod(id);
    onMethodChange?.(id);
    if (id === 'card') pickCard?.();
    if (id === 'sbp') pickSbp?.();
    if (id === 'stars') pickStars?.();
    if (id === 'Crypto') pickCrypto?.();
  };

  const handleToggleInfo = () => {
    if (toggleInfoProp) toggleInfoProp();
    else setLocalInfoOpen((v) => !v);
  };

  const handlePayment = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await onPayment?.({
        plan,
        method,
        gb: selectedGb,
        total,
        days: cur.days,
        minGb: cur.minGb,
      });
    } catch (error) {
      console.error('Payment error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (payManage) {
    return (
      <div>
        <div className="pay-manage-label">Отметьте подписки для продления:</div>
        <div className="pay-manage-list">
          {subsVM.map((sub) => (
            <div key={sub.id} onClick={sub.toggle} style={sub.rowStyle}>
              <div style={sub.checkStyle}>
                {sub.selected && (
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#06080b" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12l5 5L19 7" />
                  </svg>
                )}
              </div>
              <div className="pay-manage-item-info">
                <div className="pay-manage-item-name">{sub.name}</div>
                <div className="pay-manage-item-detail">{sub.devicesUsed ?? 0} из {sub.devices} устр. · до {sub.until}</div>
              </div>
              <span className="pay-manage-item-badge">Активна</span>
            </div>
          ))}
        </div>
        <div className="pay-manage-actions">
          {anySelected && (
            <button type="button" onClick={startRenew} className="pay-manage-renew">
              Продлить выбранные ({selectedCount})
            </button>
          )}
          <button type="button" onClick={startNew} className="pay-manage-new">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Новая подписка
          </button>
        </div>
        <div onClick={handleToggleInfo} className="pay-info-toggle">
          <div className="pay-info-toggle-inner">
            <span>Что входит, как работает трафик и условия</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8a95a3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          {infoOpen && (
            <div className="pay-info-content" onClick={(e) => e.stopPropagation()}>
              <b style={{ color: '#e8edf2' }}>В подписку входит:</b><br />
              — Неограниченная скорость.<br />
              — Безлимитный трафик на локациях без LTE.<br />
              — {deviceLimit} устройств одновременно.<br />
              — Совместимость с TV / iOS / Android / Windows / macOS / Linux.<br />
              — Трафик можно докупить в любой момент.<br /><br />
              <b style={{ color: '#e8edf2' }}>Система трафика:</b><br />
              — Трафик расходуется только на LTE-серверах.<br />
              — Минимум {minGbLabel} ГБ на выбранный срок, докупить можно больше.<br />
              — Купленный трафик не имеет срока действия и переносится на следующий период.
            </div>
          )}
        </div>
      </div>
    );
  }

  const sM1 = planM1Style ?? planCardStyle(plan === 'm1');
  const sM3 = planM3Style ?? planCardStyle(plan === 'm3');
  const sM6 = planM6Style ?? planCardStyle(plan === 'm6');
  const sM12 = planM12Style ?? planCardStyle(plan === 'm12');
  const sCard = payCardStyle ?? payMethodStyle(method === 'card');
  const sSbp = paySbpStyle ?? payMethodStyle(method === 'sbp');
  const sStars = payStarsStyle ?? payMethodStyle(method === 'stars');
  const sCrypto = payCryptoStyle ?? payMethodStyle(method === 'Crypto');

  return (
    <div>
      {hasSub && (
        <div className="pay-checkout-back">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              backToManage?.();
            }}
            style={{ color: '#c8d0d9', fontSize: '14px' }}
          >
            ← Назад к подпискам
          </a>
        </div>
      )}

      {checkoutBanner && (
        <div className="pay-checkout-banner">
          <span className="pay-checkout-dot" />
          {checkoutBanner}
        </div>
      )}

      {/* ── Тарифы ── */}
      <div className="pay-section-title">Выберите тариф</div>
      <div className="plan-grid">
        <div onClick={() => handlePickPlan('m1')} style={sM1} className="plan-card">
          <div className="plan-label">1 месяц</div>
          <div className="plan-price">299 ₽</div>
          <div className="plan-sub">299 ₽ / мес</div>
        </div>
        <div onClick={() => handlePickPlan('m3')} style={sM3} className="plan-card">
          <div className="plan-discount">−6%</div>
          <div className="plan-label">3 месяца</div>
          <div className="plan-price">849 ₽</div>
          <div className="plan-sub">283 ₽ / мес</div>
        </div>
        <div onClick={() => handlePickPlan('m6')} style={sM6} className="plan-card">
          <div className="plan-discount">−11%</div>
          <div className="plan-label">6 месяцев</div>
          <div className="plan-price">1 599 ₽</div>
          <div className="plan-sub">266 ₽ / мес</div>
        </div>
        <div onClick={() => handlePickPlan('m12')} style={sM12} className="plan-card">
          <div className="plan-discount">−25%</div>
          <div className="plan-label">12 месяцев</div>
          <div className="plan-price">2 749 ₽</div>
          <div className="plan-sub">229 ₽ / мес</div>
        </div>
      </div>

      <div className="pay-section-title">Трафик на LTE-локациях</div>
      <p className="pay-gb-hint">
        На остальных локациях трафик безлимитный. Минимум для срока — {minGbLabel} ГБ, можно докупить больше.
      </p>
      <div className="pay-gb-options">
        {gbOptions.map((g) => (
          <div
            key={g.label}
            onClick={g.pick}
            style={g.style}
            className="pay-gb-option"
          >
            {g.label} ГБ
          </div>
        ))}
      </div>

      {/* ── Способ оплаты ── */}
      <div className="pay-section-title">Способ оплаты</div>
      <div className="pay-methods">
        <div onClick={() => handlePickMethod('sbp')} style={sSbp}>
          СБП
        </div>
        <div onClick={() => handlePickMethod('card')} style={sCard}>
          Банковская карта
        </div>
        <div onClick={() => handlePickMethod('Crypto')} style={sCrypto}>
          Криптовалюта
        </div>
        {/* <div onClick={() => handlePickMethod('stars')} style={sStars}>
          Telegram Stars ⭐
        </div> */}
      </div>

      <div className="pay-checkout-summary">
        <div className="pay-checkout-summary-title">Что вы получаете</div>
        <div className="pay-checkout-summary-items">
          <div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12l5 5L19 7" />
            </svg>
            {deviceLimit} устройств одновременно
          </div>
          <div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12l5 5L19 7" />
            </svg>
            {selectedGb} ГБ трафика на LTE-локациях
          </div>
          <div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12l5 5L19 7" />
            </svg>
            Безлимитный трафик на остальных локациях
          </div>
        </div>
        <div className="pay-checkout-foot">
          <div>
            <div className="pay-checkout-units">{checkoutSummaryLabel}</div>
            <div className="pay-checkout-total">
              <span className="pay-checkout-total-label">Итого:</span>
              <span className="pay-checkout-total-value">{totalLabel} ₽</span>
            </div>
          </div>
          <button
            type="button"
            onClick={handlePayment}
            className="pay-checkout-pay-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner" />
                Обрабатываем...
              </>
            ) : (
              <>
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
                  <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
                  <path d="M2.5 9.5h19" />
                </svg>
                {payButtonLabel}
              </>
            )}
          </button>
        </div>
      </div>

      <div onClick={handleToggleInfo} className="pay-info-toggle" style={{ marginTop: 14 }}>
        <div className="pay-info-toggle-inner">
          <span>Что входит, как работает трафик и условия</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8a95a3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div>
        {infoOpen && (
          <div className="pay-info-content" onClick={(e) => e.stopPropagation()}>
            <b style={{ color: '#e8edf2' }}>В подписку входит:</b><br />
            — Неограниченная скорость.<br />
            — Безлимитный трафик на локациях без LTE.<br />
            — {deviceLimit} устройств одновременно.<br />
            — Совместимость с TV / iOS / Android / Windows / macOS / Linux.<br />
            — Трафик можно докупить в любой момент.<br /><br />
            <b style={{ color: '#e8edf2' }}>Система трафика:</b><br />
            — Трафик расходуется только на LTE-серверах.<br />
            — Минимум {minGbLabel} ГБ на выбранный срок, докупить можно больше.<br />
            — Купленный трафик не имеет срока действия и переносится на следующий период.
          </div>
        )}
      </div>

      <div className="pay-checkout-footnote">
        Нажимая «Оплатить», вы соглашаетесь с офертой. После оплаты ключ появится во вкладке «Обзор».
      </div>
    </div>
  );
};

export default Payment;